export const PROPERTY_ZONE = (communityId: string) => `v1/property-zones/community/${communityId}`;
export const PROPERTY_ZONE_WITHOUT_COMMUNITY = `v1/property-zones`;
